import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '-/Custom/ModalStack';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import getRandomColor from '@/utils/getRandomColor';
import { SelectedPersonSchema } from './ChatCreateGroup.types';

const Schema = Yup.object({
  searchTerm: Yup.string().default('').defined(),
  people: Yup.array()
    .of(SelectedPersonSchema)
    .default([])
    .defined()
    .min(2)
    .required(),
  title: Yup.string()
    .default('')
    .defined()
    .when(['isInfoStep'], ([isInfoStep], schema) =>
      isInfoStep ? schema.min(3).required() : schema,
    ),
  color: Yup.string().nullable().defined(),
  avatarId: Yup.string().nullable().defined(),
  localAvatarUrl: Yup.string().nullable().defined(),
  isInfoStep: Yup.boolean().default(false).defined(),
}).defined();

export default function ChatCreateGroupLayout() {
  const [defaultColor] = useState(() => getRandomColor());

  const form = useForm({
    resolver: yupResolver(Schema),
    mode: 'onChange',
    defaultValues: {
      searchTerm: '',
      people: [],
      title: '',
      color: defaultColor,
      avatarId: null,
      localAvatarUrl: null,
      isInfoStep: false,
    },
  });

  return (
    <FormProvider {...form}>
      <Stack />
    </FormProvider>
  );
}
